import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ad-split" }
const _hoisted_2 = { class: "ad-left" }
const _hoisted_3 = { class: "ad-right" }
const _hoisted_4 = { class: "ad-right-title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PER_ActiveEmployees = _resolveComponent("PER_ActiveEmployees")!
  const _component_ValoriParametriiSalarizare = _resolveComponent("ValoriParametriiSalarizare")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PER_ActiveEmployees, { onSelectionChanged: _ctx.handleSelectionChanged }, null, 8, ["onSelectionChanged"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[0] || (_cache[0] = _createTextVNode(" Introduceri — ", -1)),
        (_ctx.selectedMode === 'Companie')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Companie (" + _toDisplayString(_ctx.selectedLuna) + "/" + _toDisplayString(_ctx.selectedAnul) + ")", 1))
          : (_ctx.selectedMode === 'Valori implicite')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Valori implicite (" + _toDisplayString(_ctx.selectedLuna) + "/" + _toDisplayString(_ctx.selectedAnul) + ")", 1))
            : (_ctx.selectedEmpId)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "angajat selectat"))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "selectați un angajat"))
      ]),
      _createVNode(_component_ValoriParametriiSalarizare, {
        class: "ad-right-grid",
        empId: _ctx.selectedEmpId,
        mode: _ctx.selectedMode,
        luna: _ctx.selectedLuna,
        anul: _ctx.selectedAnul,
        "vezi-automat": _ctx.selectedVeziAutomat
      }, null, 8, ["empId", "mode", "luna", "anul", "vezi-automat"])
    ])
  ]))
}